module.exports = __webpack_public_path__ + "static/media/Hello10LogoSquareCentered.093b8dea.png";